export const joinQueryParams = (
  baseUrl: string,
  currentUrl?: string,
  staticQueryParams?: Record<string, string | undefined>,
): string => {
  const currentUrlParams = currentUrl?.split('?')[1];

  if (!currentUrlParams) {
    if (staticQueryParams) {
      const arrStaticQueryParams = Object.entries(staticQueryParams);
      const staticQueryParamsString = arrStaticQueryParams
        .map(([key, value], index) => {
          if (value !== undefined) {
            return `${index === 0 ? '' : '&'}${key}=${value}`;
          }
        })
        .join('');

      return `${baseUrl}?${staticQueryParamsString}`;
    }

    return baseUrl;
  }

  const queryCurrentUrl = currentUrlParams.split('&').reduce((acc, current) => {
    const [key, value] = current.split('=');
    return { ...acc, [key]: value };
  }, {});

  const allQueryParams = { ...queryCurrentUrl, ...staticQueryParams };

  const arrAllQueryParams = Object.entries(allQueryParams);

  const stringQueryParams = arrAllQueryParams
    .map(([key, value], i) => {
      if (value !== undefined) {
        return `${i === 0 ? '' : '&'}${key}=${value}`;
      }
    })
    .join('');
  if (!baseUrl.includes('?')) {
    return `${baseUrl}?${stringQueryParams}`;
  }

  return `${baseUrl}&${stringQueryParams}`;
};
